module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/meal-ed618487ec10710e043e78ec60e848ba.webp";